import React from "react";

function Header() {
  return (
    <React.Fragment>
      <p id="header-title">Good Food (demo)</p>
    </React.Fragment>
  );
}

export default Header;